import makeStyles from '@material-ui/core/styles/makeStyles';

export const useTableMenuStyles = makeStyles({
    paper: {
        border: '1px solid #d3d4d5',
        padding: '0.45rem',
        borderRadius: '8px',
        boxShadow: '0 0 20px -10px #00000054',
    },
    list: { padding: '0rem' },
    menuItemRoot: {
        fontSize: '0.875rem',
        paddingTop: '0.4rem',
        paddingBottom: '0.4rem',
        paddingLeft: '0.4rem',
        margin: '0.3rem 0',
        color: 'black',
        paddingRight: '0.7rem',
        minWidth: '97px',
        '&:focus': {
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: 'white'
            },
        },
    },
});
